import { useState } from "react";
import { Box, Typography } from "@mui/material";

// A value with no natural spaces to break on — a banner string, a base64 blob,
// a long model/serial code — otherwise forces its container to overflow, or
// gets wrapped one character per line when the column has been squeezed by a
// sibling. Clamped to a couple of lines by default; a native `title` carries
// the full text for a hover tooltip, and anything genuinely long gets an
// explicit "Show more" toggle rather than silently growing the page.
const TruncatedText = ({ children, mono = false, maxChars = 140, clampLines = 2, align = "left", alwaysExpanded = false }) => {
  const [expanded, setExpanded] = useState(false);
  const text = children == null ? "" : String(children);
  if (!text) return null;
  // A caller that's already committed to showing everything (a "full detail"
  // dialog, say) has no use for a "Show more" toggle — it would just be an
  // extra click to reveal text that's supposed to be there by default.
  const isLong = !alwaysExpanded && text.length > maxChars;

  return (
    <Box sx={{ minWidth: 0, textAlign: align }}>
      <Typography
        title={text}
        onClick={isLong ? () => setExpanded((v) => !v) : undefined}
        sx={{
          fontSize: "inherit",
          fontFamily: mono ? "monospace" : undefined,
          color: "inherit",
          wordBreak: "break-word",
          cursor: isLong ? "pointer" : "default",
          ...(expanded || alwaysExpanded
            ? {}
            : {
                display: "-webkit-box",
                WebkitLineClamp: clampLines,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }),
        }}
      >
        {text}
      </Typography>
      {isLong && (
        <Typography
          onClick={() => setExpanded((v) => !v)}
          sx={{ fontSize: 10, color: "#459095", cursor: "pointer", mt: 0.2, fontWeight: 600 }}
        >
          {expanded ? "Show less" : "Show more"}
        </Typography>
      )}
    </Box>
  );
};

export default TruncatedText;
